import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ProductoService } from '../producto.service';

@Component({
  selector: 'app-producto-stocks',
  templateUrl: './producto-stocks.component.html',
  styleUrls: ['./producto-stocks.component.scss']
})
export class ProductoStocksComponent implements OnInit {
  id!: number
  tableItems: any[] = [];
  columnas: any[] = [
    {
      label: "Producto",
      attribute: "producto",
      responsive: ['XS', 'SM', 'MD'],
      value: (el: any) => {
        return el.producto.nombre
      }
    },
    {
      label: "Sucursal",
      attribute: "sucursal",
      responsive: ['XS', 'SM', 'MD'],
      value: (el: any) => {
        return el.sucursal.nombre
      }
    },
    {
      label: "Cantidad",
      attribute: "cantidad",
      responsive: ['XS', 'SM', 'MD'],
      value: (el: any) => {
        return this.formatter.numberFormat(el.cantidad)
      }
    }
  ]
  constructor(
    public config: ConfigService,
    public formatter: FormatterService,
    private loading: LoadingService,
    private alerts: AlertService,
    private modalService: NgbModal,
    public service: ProductoService,
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.id = this.service.id;
    this.stoks(this.id)
  }

  stoks(id: any) {
    this.loading.show()
    this.service.stock_sucursales(id).subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.tableItems = res



      }, error: (err: any) => {
        this.loading.hide();
        if (err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }
}
